////////LIBRARY/////////
import { replace, isNumber, toNumber, isString, split, isUndefined } from 'lodash'

class PriceFormatter {
	/**
	 *
	 * @param {*} price number that we want formatted (mandatory)
	 * @param {*} currency should be mandatory ?
	 * @param {*} price2 number that we want to operate with first one
	 * @param {*} operator what math operation we want
	 */
	static PriceFormatter(price, currency = '', price2 = '', operator = '') {
		// Set up the first price with two digit
		let p1 = parseFloat(price).toFixed(2)

		if (price2 !== '' && operator !== '') {
			let p2 = parseFloat(price2).toFixed(2)
			let p_final
			switch (operator) {
				case '+':
					p_final = p1 + p2
					break
				case '-':
					p_final = p1 - p2
					break
				case '*':
					p_final = p1 * p2
					break
				case '/':
					p_final = p1 / p2
					break
				default:
					break
			}
			p_final = p_final.toFixed(2)

			return `${p_final}${currency}`
		} else {
			return `${p1}${currency}`
		}
	}

	/**
	 *
	 * @param stringValue
	 * @return {number}
	 */
	static stringToNumberInput(stringValue) {
		let n = Number(replace(replace(split(stringValue, ' - ')[0], '€', ''), ',', '.'))
		return n.toFixed(2)
	}

	/**
	 *
	 * @param{boolean} withVAT
	 * @param{number} inputValue
	 * @param {number} inputTaxesRate integer
	 * @example
	 * withVAT = true
	 * value = 10
	 * taxesRates = 20
	 * @return {string}
	 */
	static vatConverter(withVAT, inputValue, inputTaxesRate) {
		let value = inputValue
		let taxesRate = inputTaxesRate
		if (!isNumber(value) && !isUndefined(value)) value = this.stringToNumber(value)
		if (!isNumber(taxesRate) && !isUndefined(taxesRate)) taxesRate = this.stringToNumber(taxesRate)

		let convertedValue = 0

		const taxesToApply = 1 + taxesRate / 100

		if (withVAT) {
			convertedValue = value * taxesToApply
		} else {
			convertedValue = value / taxesToApply
		}
		return convertedValue.toFixed(2) || '0'
	}

	/**
	 *
	 * @param {string}  inputValue
	 * @return {number}
	 */
	static stringToNumber = (inputValue) => {
		if (!isString(inputValue)) throw new Error(`inputValue is ${typeof inputValue} and a String was expected`)

		let value = inputValue

		if (value.includes(',')) value = replace(value, ',', '.')

		value = toNumber(value)

		if (!isNumber(value)) throw new Error('The value can not be convert to number')

		return value
	}
}

export default PriceFormatter
